module.exports = __webpack_public_path__ + "img/content-r-1.f39436c0.png";